import { RESET_ROLL_DOWN_INCOME_UNIT, ROLL_DOWN_INCOME_UNIT } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";

// Define an initial state value for the app
const initialState: BaseAsyncReducerState = {
    loading: false,
    success: false,
    error: false
}
  
function rollDownUnitReducer(state = initialState, action: AppAction | LocalAction) {

    switch (action.type) {
        case ROLL_DOWN_INCOME_UNIT.PENDING:
            return {
                loading: true,
                success: false,
                error: false,
            }

        case ROLL_DOWN_INCOME_UNIT.SUCCESS:
            return {
                ...state,
                success: (action as AppAction).payload.success,
                status: (action as AppAction).payload.status,
                loading: false,
                error: false,
            }

        case ROLL_DOWN_INCOME_UNIT.ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: true
            }

        case RESET_ROLL_DOWN_INCOME_UNIT:
            return {
                ...initialState
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default rollDownUnitReducer;